import { axiosInstance as axios } from "configs/axiosConfig";

export const getS3presign = ({ key }) => {
  // console.log(key);
  return new Promise((resolve, reject) => {
    try {
      const url = `awss3/s3-presign`;
      axios.post(url, { key }).then((res) => {
        resolve(res.data);
      });
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
